import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 6/11;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 6 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Overview" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Team-overview---profile---2" transform="translate(-1194.000000, -457.000000)" fill={color}>
                <g id="Rectangle-4" transform="translate(232.000000, 30.000000)">
                    <g id="Group-41" transform="translate(35.000000, 278.000000)">
                        <g id="Group-40" transform="translate(0.000000, 72.000000)">
                            <g id="Group-36-Copy-2" transform="translate(900.000000, 22.000000)">
                                <path d="M32.8047379,56.1380712 C33.0650874,55.8777217 33.0650874,55.4556117 32.8047379,55.1952621 C32.5443883,54.9349126 32.1222783,54.9349126 31.8619288,55.1952621 L27.1952621,59.8619288 C26.9349126,60.1222783 26.9349126,60.5443883 27.1952621,60.8047379 L31.8619288,65.4714045 C32.1222783,65.731754 32.5443883,65.731754 32.8047379,65.4714045 C33.0650874,65.211055 33.0650874,64.788945 32.8047379,64.5285955 L28.6094757,60.3333333 L32.8047379,56.1380712 Z" id="Path-82" transform="translate(30.000000, 60.333333) translate(-30.000000, -60.333333) "></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export default class IconArrowLeft extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
